import React from "react";
import Button from "../components/atoms/Button";
import SubHeading from "../components/atoms/SubHeading";
import Modal from "../components/molecules/Modal";
import ModalEditProfile from "../components/organisms/perfil/ModalEditProfile";
import useModal from "../hooks/useModal";
import { useSession } from "../context/SessionContext";
import CardHeader from "../components/atoms/CardHeader";
import Breadcrumb from "../components/molecules/Breadcrumb";

const Perfil = () => {
    const { user } = useSession();
    const { open, close, isOpen } = useModal();

    const info = [
        { text:"Correo:" },
        { text:user?.email },
        { text:"Rol:" },
        { text:user?.role },
        { text:"Nombre:" },
        { text:user?.roleInfo?.name },
    ];

    return(
        <div className="w-full h-full flex flex-col space-y-8">
            <CardHeader>
                <Breadcrumb
                    items={[
                        { label: "Inicio", to: "/dashboard" },
                        { label: "Perfil", to: null },
                    ]}
                />
            </CardHeader>
            <div className="w-full h-full flex flex-col justify-center items-center space-y-8">
                <div className="relative w-full lg:w-4/5 md:w-1/2 h-full lg:h-64 bg-rs-azul rounded-xl shadow-lg shadow-black text-white overflow-hidden group transition-all duration-300">
                    <div className="p-4 space-y-2">
                        {info.map((i, index) =>(
                            <SubHeading text={i.text} key={index} color="white"/>
                        ))}
                    </div>
                    <div className="absolute bottom-0 left-0 w-full h-full bg-white/10 flex items-center justify-center translate-y-full rounded-lg group-hover:translate-y-0 transition-transform duration-500 backdrop-blur-md ">
                        <Button text="Editar" bgColor="red" onClick={open} />
                    </div>
                </div>
            </div>
            {isOpen && 
                <Modal title="Editar información" onClose={close} >
                    <ModalEditProfile user={user} onClose={close} />
                </Modal>
            }
        </div>
    );
};

export default Perfil;